/**
 * DURÉE RÉMUNÉRÉE — AUTORITÉ UNIQUE, PARTAGÉE SERVEUR ET NAVIGATEUR.
 *
 * ═══ POURQUOI CE FICHIER VIT ICI ═══
 *
 * La règle « le temps payé, c'est la présence moins la seule pause NON payée »
 * était écrite DEUX FOIS : dans le cœur métier, et de nouveau dans le
 * formulaire de planning React. Deux écritures d'une même règle finissent
 * toujours par diverger — et une troisième en Swift aurait donné trois vérités
 * sur la matière qui part en paie.
 *
 * Ce module est volontairement SANS AUCUNE dépendance Node : il se charge
 * aussi bien dans l'API que dans un navigateur. `packages/core` le réexporte,
 * `apps/web` l'importe par le sous-chemin `@gestion/shared/duration`, et le
 * contrat borne dit à l'application native de ne JAMAIS recalculer : elle
 * affiche `summary.paid_minutes` tel que le serveur le donne.
 */
/** Durée calendaire entre le début et la fin, pauses comprises (minutes). */
export function scheduledSpan(s) {
    return Math.max(0, Math.round((s.ends_at.getTime() - s.starts_at.getTime()) / 60_000));
}
/** Durée totale de pause (minutes). */
export function breakDuration(s) {
    return Math.max(0, Math.round(s.break_minutes));
}
/** Part de la pause qui reste PAYÉE (comptée comme du temps rémunéré). */
export function paidBreakDuration(s) {
    return s.break_paid ? breakDuration(s) : 0;
}
/** Part de la pause NON payée (déduite de la durée rémunérée). */
export function unpaidBreakDuration(s) {
    return s.break_paid ? 0 : breakDuration(s);
}
/**
 * DURÉE RÉMUNÉRÉE (minutes) : présence moins la seule pause NON payée.
 *
 * Un service 23:00→06:00 (7 h de présence) avec 20 min de pause ne vaut PAS
 * automatiquement 6 h 40 payées : si la pause est rémunérée, la durée
 * rémunérée reste 7 h.
 */
export function paidDuration(s) {
    return Math.max(0, scheduledSpan(s) - unpaidBreakDuration(s));
}
/** Décomposition complète — pour l'API, les totaux, les aperçus et les tests. */
export function decomposeDuration(s) {
    return {
        scheduled_span: scheduledSpan(s),
        break_duration: breakDuration(s),
        paid_break_duration: paidBreakDuration(s),
        unpaid_break_duration: unpaidBreakDuration(s),
        paid_duration: paidDuration(s),
    };
}
/** Aperçu depuis des minutes brutes — ce dont un formulaire a besoin, sans fabriquer de Date. */
export function paidMinutesFromSpan(spanMinutes, breakMinutes, breakPaid) {
    return Math.max(0, Math.round(spanMinutes) - (breakPaid ? 0 : Math.max(0, Math.round(breakMinutes))));
}
//# sourceMappingURL=duration.js.map